<template>
  <v-app-bar app dense dark>
    <v-toolbar-title>
      <a @click="$router.push({ name: 'playbook' })" class="dw_green--text font-weight-light">
        Pentesting Playbook
      </a>
    </v-toolbar-title>
    <v-spacer />
    <v-btn
      v-if="permissions.user(groups)"
      icon
      @click="$router.push({ name: 'contribute' })"
      title="Update the Playbook">
      <v-icon v-text="mdiFeather" />
      <v-badge
        v-if="this.permissions.moderator(this.groups) && pendingCount > 0"
        :content="pendingCount"
        bordered
        top
        color="info"></v-badge>
    </v-btn>
    <v-btn icon @click="$router.push({ name: 'faqs' })" title="FAQs">
      <v-icon v-text="mdiFrequentlyAskedQuestions" />
    </v-btn>
    <a href="https://forms.gle/KApLKJsFsQdViKrbA" target="_blank">
      <v-btn icon title="Give Feedback">
        <v-icon v-text="mdiCommentFlashOutline" />
      </v-btn>
    </a>
    <a href="https://forms.gle/EAEnXJLL44WaHGBq6" target="_blank">
      <v-btn icon title="Bug Report/Feature Request">
        <v-icon v-text="mdiShieldBugOutline" />
      </v-btn>
    </a>
    <v-menu top v-model="userMenu" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon title="Profile" v-bind="attrs" v-on="on">
          <v-icon v-text="mdiAccountBoxOutline" />
        </v-btn>
      </template>

      <v-list color="bg_darker">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title>
              <v-icon v-text="mdiAccount" class="mr-1" />
              {{ $auth.user.name || 'Local User' }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $auth.user.email || 'fake.email@darkwolfsolutions.com' }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="dw_green--text">
              {{ $auth.user.role }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="logout">
          <v-list-item-content>
            <span class="text-right">Logout</span>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon v-text="mdiLogoutVariant" title="Logout" />
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
  mdiFeather,
  mdiFrequentlyAskedQuestions,
  mdiCommentFlashOutline,
  mdiShieldBugOutline,
  mdiAccountBoxOutline,
  mdiAccount,
  mdiLogoutVariant
} from '@mdi/js';
import EventBus from '@/utils/eventBus';

export default {
  name: 'navbar',
  inject: ['permissions'],
  data() {
    return {
      mdiFeather,
      mdiFrequentlyAskedQuestions,
      mdiCommentFlashOutline,
      mdiShieldBugOutline,
      mdiAccountBoxOutline,
      mdiAccount,
      mdiLogoutVariant,
      userMenu: false
    }
  },
  computed: {
    ...mapGetters([
      'groups',
      'pendingCount'
    ])
  },
  created() {
    EventBus.$on('authError', async (status) => {
      await this.logout();
      const errText = status === 401 ? 'Authorization Error' : 'Authentication Error';
      this.throwAuthError(errText);
    });
  },
  mounted() {
    if (this.permissions.moderator(this.groups)) this.fetchPendingCount();
  },
  methods: {
    ...mapActions([
      'fetchPendingCount'
    ]),
    ...mapMutations([
      'resetState',
      'throwAuthError'
    ]),
    async logout() {
      this.resetState();
      try {
        await this.$auth.signOut();
      } catch {
        this.throwAuthError('Error logging out.');
      }
      this.$router.push({ name: 'login' });
    }
  }
};
</script>
